import { HalfContainer } from "common/common.styled";
import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import {
    eyeColorOptions,
    hairColorOptions,
    tattoosOptions,
} from "pages/Profile/EditProfile/PhysicalDetails/constants";
import { FC } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import theme from "theme";
import { JobPurposeWrapper } from "../JobPurpose/JobPurpose.styled";
import { JobDetailsWrapper } from "./JobAdvanceDetails.styled";
import { useJobDetails } from "./useAdvanceJobDetails";

export const JobAdvanceDetails: FC = () => {
    const {
        agencyName,
        purposeName,
        location,
        textInputs,
        textInputsErrors,
        dropdownInputs,
        dropdownInputsErrors,
        handleDropdownChange,
        handleTextInputChange,
        handleBack,
        handleNext,
    } = useJobDetails();
    return (
        <JobPurposeWrapper>
            <HalfContainer>
                <Text variant="body3" color={theme.colors.grey.primary}>
                    I am posting a job on behalf of{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {agencyName}
                    </Text>{" "}
                    for a{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {purposeName}{" "}
                    </Text>
                    in{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {location}
                    </Text>
                </Text>
                <JobDetailsWrapper>
                    <Text variant="button1">Advanced Details</Text>
                    <Grid row={true} columnGap={1} expanded>
                        <SingleSelect
                            options={[
                                {
                                    value: "Graduation",
                                    label: "Graduation",
                                },
                                {
                                    value: "Post Graduation",
                                    label: "Post Graduation",
                                },
                            ]}
                            label="Qualification"
                            // minWidth="10rem"
                            // required
                            placeholder="Graduation"
                            value={dropdownInputs.qualification}
                            errorText={dropdownInputsErrors.qualification}
                            onChange={(value) =>
                                handleDropdownChange("qualification", value)
                            }
                        />
                    </Grid>
                    <Grid row={true} columnGap={1} expanded>
                        <SingleSelect
                            options={eyeColorOptions}
                            label="Eye color"
                            // minWidth="10rem"
                            searchable
                            placeholder="Select Eyecolor"
                            required
                            value={dropdownInputs.eye_color}
                            onChange={(value) =>
                                handleDropdownChange("eye_color", value)
                            }
                            errorText={dropdownInputsErrors.eye_color}
                        />
                        <SingleSelect
                            options={tattoosOptions}
                            label="Tattoos"
                            // minWidth="10rem"
                            placeholder="Select tattoos"
                            value={dropdownInputs.tattoos}
                            searchable
                            required
                            onChange={(value) =>
                                handleDropdownChange("tattoos", value)
                            }
                            errorText={dropdownInputsErrors.tattoos}
                        />
                        <SingleSelect
                            options={hairColorOptions}
                            label="Hair color"
                            // minWidth="8rem"
                            searchable
                            required
                            placeholder="Select haircolor"
                            value={dropdownInputs.hair_color}
                            onChange={(value) =>
                                handleDropdownChange("hair_color", value)
                            }
                            errorText={dropdownInputsErrors.hair_color}
                        />
                        <TextInput
                            label="Hair length(cm)"
                            type="number"
                            // minWidth="10rem"
                            required
                            placeholder="Enter hair length"
                            name="hair_length"
                            value={textInputs.hair_length}
                            errorMsg={textInputsErrors.hair_length}
                            onChange={handleTextInputChange}
                        />
                        <SingleSelect
                            options={tattoosOptions}
                            label="Piercings"
                            // minWidth="10rem"
                            required
                            placeholder="Select Piercings"
                            value={dropdownInputs.piercings}
                            onChange={(value) =>
                                handleDropdownChange("piercings", value)
                            }
                            errorText={dropdownInputsErrors.piercings}
                        />
                    </Grid>
                    <Grid row={true} columnGap={1} expanded>
                        <TextInput
                            label="Weight(min)(kg)"
                            type="number"
                            // minWidth="10rem"
                            // required
                            placeholder="Enter min weight"
                            name="minWeight"
                            value={textInputs.minWeight}
                            errorMsg={textInputsErrors.minWeight}
                            onChange={handleTextInputChange}
                        />
                        <TextInput
                            label="Weight(max)(kg)"
                            type="number"
                            // minWidth="10rem"
                            // required
                            placeholder="Enter max weight"
                            name="maxWeight"
                            value={textInputs.maxWeight}
                            errorMsg={textInputsErrors.maxWeight}
                            onChange={handleTextInputChange}
                        />
                    </Grid>
                    <Grid row={true} columnGap={1} expanded>
                        <TextInput
                            label="Height(min)(cm)"
                            type="number"
                            // minWidth="10rem"
                            // required
                            placeholder="Enter min height"
                            name="minHeight"
                            value={textInputs.minHeight}
                            errorMsg={textInputsErrors.minHeight}
                            onChange={handleTextInputChange}
                        />
                        <TextInput
                            label="Height(max)(kg)"
                            type="number"
                            // minWidth="10rem"
                            // required
                            placeholder="Enter max height"
                            name="maxHeight"
                            value={textInputs.maxHeight}
                            errorMsg={textInputsErrors.maxHeight}
                            onChange={handleTextInputChange}
                        />
                    </Grid>

                    <Grid row={true} columnGap={1} expanded>
                        <TextInput
                            label="Bust(cm)"
                            type="number"
                            // minWidth="10rem"
                            // required
                            placeholder="Enter bust size"
                            name="bust"
                            value={textInputs.bust}
                            errorMsg={textInputsErrors.bust}
                            onChange={handleTextInputChange}
                        />
                        <TextInput
                            label="Waist(cm)"
                            type="number"
                            // minWidth="10rem"
                            // required
                            placeholder="Enter waist size"
                            name="waist"
                            value={textInputs.waist}
                            errorMsg={textInputsErrors.waist}
                            onChange={handleTextInputChange}
                        />
                        <TextInput
                            label="Hips(cm)"
                            type="number"
                            // minWidth="10rem"
                            // required
                            placeholder="Enter hips size"
                            name="hips"
                            value={textInputs.hips}
                            errorMsg={textInputsErrors.hips}
                            onChange={handleTextInputChange}
                        />
                    </Grid>
                    <Grid marginTop={3} marginBottom={2} columnGap={1}>
                        <Button
                            type="button"
                            variant="outlined"
                            icon={<BsArrowLeft />}
                            iconPosition="prefix"
                            onClick={handleBack}
                        >
                            Back
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            icon={<BsArrowRight />}
                            iconPosition="suffix"
                            onClick={handleNext}
                        >
                            Next
                        </Button>
                    </Grid>
                </JobDetailsWrapper>
            </HalfContainer>
        </JobPurposeWrapper>
    );
};
